/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OrganizationOnboarding,
    OrganizationOnboardingFromJSON,
    OrganizationOnboardingFromJSONTyped,
    OrganizationOnboardingToJSON,
    OrganizationOnboardingDetailsAllOf,
    OrganizationOnboardingDetailsAllOfFromJSON,
    OrganizationOnboardingDetailsAllOfFromJSONTyped,
    OrganizationOnboardingDetailsAllOfToJSON,
    OrganizationType,
    OrganizationTypeFromJSON,
    OrganizationTypeFromJSONTyped,
    OrganizationTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrganizationOnboardingDetails
 */
export interface OrganizationOnboardingDetails {
    /**
     * 
     * @type {string}
     * @memberof OrganizationOnboardingDetails
     */
    organizationName?: string;
    /**
     * 
     * @type {OrganizationType}
     * @memberof OrganizationOnboardingDetails
     */
    organizationType?: OrganizationType;
    /**
     * The preferred locale used for communication, in BCP 47 format.
     * @type {string}
     * @memberof OrganizationOnboardingDetails
     */
    organizationLocale?: string;
    /**
     * Google Place ID
     * @type {string}
     * @memberof OrganizationOnboardingDetails
     */
    firstWorkspaceLocation?: string;
    /**
     * Name of the first workspace, optional. If not set, this will be the street address from firstWorkspaceLocation
     * @type {string}
     * @memberof OrganizationOnboardingDetails
     */
    firstWorkspaceName?: string;
    /**
     * The unique identifier for the connection.
     * @type {string}
     * @memberof OrganizationOnboardingDetails
     */
    connectionId?: string;
    /**
     * The token for the email address of the owning user/first admin. For companies, the domain of the email address will also be associated with this organization and no other companies can use it.
     * @type {string}
     * @memberof OrganizationOnboardingDetails
     */
    ownerEmailToken?: string;
    /**
     * The user-friendly address to show the user in place of a Google Place ID
     * @type {string}
     * @memberof OrganizationOnboardingDetails
     */
    formattedAddress?: string;
}

export function OrganizationOnboardingDetailsFromJSON(json: any): OrganizationOnboardingDetails {
    return OrganizationOnboardingDetailsFromJSONTyped(json, false);
}

export function OrganizationOnboardingDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationOnboardingDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organizationName': !exists(json, 'organizationName') ? undefined : json['organizationName'],
        'organizationType': !exists(json, 'organizationType') ? undefined : OrganizationTypeFromJSON(json['organizationType']),
        'organizationLocale': !exists(json, 'organizationLocale') ? undefined : json['organizationLocale'],
        'firstWorkspaceLocation': !exists(json, 'firstWorkspaceLocation') ? undefined : json['firstWorkspaceLocation'],
        'firstWorkspaceName': !exists(json, 'firstWorkspaceName') ? undefined : json['firstWorkspaceName'],
        'connectionId': !exists(json, 'connectionId') ? undefined : json['connectionId'],
        'ownerEmailToken': !exists(json, 'ownerEmailToken') ? undefined : json['ownerEmailToken'],
        'formattedAddress': !exists(json, 'formattedAddress') ? undefined : json['formattedAddress'],
    };
}

export function OrganizationOnboardingDetailsToJSON(value?: OrganizationOnboardingDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organizationName': value.organizationName,
        'organizationType': OrganizationTypeToJSON(value.organizationType),
        'organizationLocale': value.organizationLocale,
        'firstWorkspaceLocation': value.firstWorkspaceLocation,
        'firstWorkspaceName': value.firstWorkspaceName,
        'connectionId': value.connectionId,
        'ownerEmailToken': value.ownerEmailToken,
        'formattedAddress': value.formattedAddress,
    };
}


